'use client';

import { useDismissed } from '@/hooks/use-dismissed';

interface PromoBannerClientProps {
  headline: string;
  /** Stripe promo code — used only as the dismissal key so a new promo re-shows. */
  code: string;
  /** Absolute Start a life story URL, already carrying campaign params. */
  href: string;
}

function dismissKey(code: string): string {
  return `promo-dismissed:${code}`;
}

export function PromoBannerClient({ headline, code, href }: PromoBannerClientProps) {
  const [dismissed, dismiss] = useDismissed(dismissKey(code));

  if (dismissed) return null;

  return (
    <aside className="promo-bar" role="region" aria-label="Promotion">
      {/* One link for headline + CTA: the 2026-09 replay review showed visitors tapping
          the headline text and getting nothing. The dismiss button stays a sibling so no
          interactive element is nested inside the link. */}
      <a href={href} className="promo-bar-link">
        {/* No rule targets .promo-bar-text; it stays so PostHog autocapture element chains
            keep telling headline taps from CTA taps (how the dead clicks were found). */}
        <span className="promo-bar-text">{headline}</span>
        <span className="promo-bar-cta">
          Start a life story <span aria-hidden="true">→</span>
        </span>
      </a>
      <button
        type="button"
        className="promo-bar-dismiss"
        aria-label="Dismiss promotion"
        onClick={dismiss}
      >
        <span aria-hidden="true">×</span>
      </button>
    </aside>
  );
}
